import { Injectable } from '@angular/core';

const eventCleanupDelay = 1000;

/**
 * Registers map events that have been handled so that they can be recognized and ignored by further handlers.
 * This is required as stopPropagation prevents desired bubbling events.
 */
@Injectable({ providedIn: 'root' })
export class MapEventPropagationService {
    private _eventsTimeStampsToIgnore = new Array<number>();

    public shouldIgnoreEvent(event: Event): boolean {
        return this._eventsTimeStampsToIgnore.includes(event.timeStamp);
    }

    public registerEvent(event: Event): void {
        this._eventsTimeStampsToIgnore.push(event.timeStamp);

        this._planEventCleanup();
    }

    private _planEventCleanup(): void {
        setTimeout(
            () => {
                this._cleanupEvents();
            },
            eventCleanupDelay,
        );
    }

    /**
     * Delete all events that are older than the limit.
     */
    private _cleanupEvents(): void {
        const now = new Date().getTime();

        this._eventsTimeStampsToIgnore
            = this._eventsTimeStampsToIgnore
                .filter(timeStamp => timeStamp + eventCleanupDelay < now);
    }
}
